export default function CancelToken() {
    this.cancel = () => {};
}
